import ImportExportComp from './ImportExportComp.vue'
export default function (app) {
  app.component('ImportExportComp', ImportExportComp)
}
